<template>
  <div class="prepare-question">
    <QuestionHead :isSubmit="isSubmit" />
    <QuestionChoice v-if="questionDetail.type === typeRadio" :isSubmit="isSubmit" :notCorrect="notCorrect" />
    <QuestionMultiChoice v-else-if="questionDetail.type === typeCheckbox" :isSubmit="isSubmit" :notCorrect="notCorrect" />
    <QuestionDownAnswer v-else-if="questionDetail.type === typeDownAnswer" :isSubmit="isSubmit" />
    <a
      href="javascript:;"
      class="btn btn-gray btn-add-question font-size-16 display-flex-center justify-content-center border-rd-4 full-width primary-color font-sanpro-semibold"
      @click="addNewQuestion()"
    > <!-- addNewQuestion is function of mixinsCreateQuestion -->
      <i class="icon-plus"></i> Thêm câu hỏi
    </a>
    <div class="prepare-question__footer  justify-content-end display-flex mt-4">
      <!-- <a href="javascript:;" class="color-err font-size-17 font-sanpro-semibold" @click.prevent="removeQuestion()">Xóa câu hỏi</a> -->
      <div class="display-flex-center">
        <a href="javascript:;" class="color-err font-size-16 font-sanpro-semibold" @click.prevent="removeQuestion()">Xóa câu hỏi</a>
        <!-- <button
          type="button"
          class="btn btn-main btn-save border-rd-20 font-size-16 font-sanpro-semibold justify-content-center display-flex-center"
          @click.prevent="handleSaveQuestion()"
        >
          Lưu câu hỏi
        </button> -->
      </div>
      <span class="secondary-color-txt font-sanpro-light font-size-15">Giáo viên lưu ý thường xuyên bấm "Lưu đề thi" để cập nhật nội dung đề thi</span>
      <!-- <div class="display-flex-center">
        <a href="javascript:;" class="color-err font-size-17 font-sanpro-semibold" @click.prevent="removeQuestion()">Xóa câu hỏi</a>
        <button type="button" class="btn btn-main btn-save border-rd-20 font-size-16 font-sanpro-semibold justify-content-center display-flex-center" @click.prevent="handleSaveQuestion()">Lưu</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import QuestionHead from './QuestionHead.vue'
import QuestionChoice from './QuestionChoice.vue'
import QuestionMultiChoice from './QuestionMultiChoice.vue'
import QuestionDownAnswer from './QuestionDownAnswer.vue'
import { STORE_KEY, CONTENT_EDITOR_DEFAULT } from './../../_store/constants'
import { apiCreateQuestion, apiQuestionDelete, apiUpdateQuestion, apiGetDetailQuestion } from './../../_api/exam'
import { TYPE_RADIO, TYPE_DOWN_ANSWER, TYPE_CHECKBOX } from '@/modules/question/preview-question/_store/constants'
import mixinsCreateQuestion from './../../_store/mixinsCreateQuestion'

export default {
  name: 'QuestionDetail',
  mixins: [ mixinsCreateQuestion ],
  components: {
    QuestionHead,
    QuestionChoice,
    QuestionMultiChoice,
    QuestionDownAnswer
  },
  data () {
    return {
      typeRadio: TYPE_RADIO,
      typeDownAnswer: TYPE_DOWN_ANSWER,
      typeCheckbox: TYPE_CHECKBOX,
      isSubmit: false,
      notCorrect: false
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['questionDetail', 'indexQuestionWorking', 'questionList'])
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetListQuestions', 'acSetQuestionIndexWorking', 'acSetQuestionDetail']),

    handleSaveQuestion () {
      this.isSubmit = true
      if (!this.handleValidateQuestionSave()) {
        return
      }
      if (this.questionDetail.questionId && this.questionDetail.questionId > 0) {
        this.updateQuestion()
      } else {
        this.createQuestion()
      }
    },

    handleValidateQuestionSave () {
      return !this.questionDetail.title || !this.questionDetail.content || (this.questionDetail.content && this.questionDetail.content === CONTENT_EDITOR_DEFAULT) || !this.questionDetail.answers || this.questionDetail.answers.length === 0 || !this.handleValidateAnswers() ? false : true
      // if (!this.questionDetail.title || !this.questionDetail.content || (this.questionDetail.content && this.questionDetail.content === CONTENT_EDITOR_DEFAULT) || !this.questionDetail.answers || this.questionDetail.answers.length === 0 || !this.handleValidateAnswers()) {
      //   return false
      // } else {
      //   return true
      // }
    },

    handleValidateAnswers () {
      let self = this
      let lengthAnswers = self.questionDetail.answers.length;
      if (self.questionDetail.type !== TYPE_DOWN_ANSWER) {
        let correct = self.questionDetail.answers.findIndex(ans => ans.correct)
        if (correct === -1) {
          self.notCorrect = true
          return false
        }
      }
      for(let i = 0; i < lengthAnswers; i++) {
        if ((!self.questionDetail.answers[i].code && self.questionDetail.type !== TYPE_DOWN_ANSWER) || !self.questionDetail.answers[i].content || (self.questionDetail.answers[i].content && self.questionDetail.answers[i].content === CONTENT_EDITOR_DEFAULT)) {
          return false;
          break;
        } else if (i === lengthAnswers - 1) {
          return true
        }
      }
    },

    getQuestionDetail (id) {
      let self = this
      self.setLoading(true)
      apiGetDetailQuestion(id).then(data => {
        if (data) {
          data.answers && data.answers.map(ans => {
            if (ans.correct) {
              ans['answerContent'] = ans.orderNo
            }
          })
          self.acSetQuestionDetail(data)
          self.questionList[self.indexQuestionWorking] = data
          self.acSetListQuestions([...self.questionList])
        }
      }).finally(() => self.setLoading(false))
    },

    createQuestion () {
      let self = this
      self.setLoading(true)
      apiCreateQuestion(self.questionDetail).then(res => {
        if (res && res.questionId) {
          self.getQuestionDetail(res.questionId)
          self.$toast.success('Lưu câu hỏi thành công!')
        }
      }).finally(() => {
        self.setLoading(false)
        self.isSubmit = false
      })
    },

    updateQuestion () {
      let self = this
      self.setLoading(true)
      apiUpdateQuestion(self.questionDetail)
      .then(res => {
        res && self.$toast.success('Lưu câu hỏi thành công!')
      })
      .finally(() => {
        self.setLoading(false)
        self.isSubmit = false
      })
    },

    async removeQuestion () {
      let self = this
      self.setLoading(true)
      if (self.indexQuestionWorking === -1) {
        self.$toast.error('Không tìm thấy câu hỏi cần xoá!')
        return;
      }
      if (self.questionDetail.questionId) {
        let questionDel = await apiQuestionDelete(self.questionDetail.questionId)
      }
      self.questionList.splice(self.indexQuestionWorking, 1)
      self.acSetListQuestions([...self.questionList])
      self.acSetQuestionDetail({})
      self.acSetQuestionIndexWorking(-1)
      self.$toast.success('Xoá câu hỏi thành công!')
      self.setLoading(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.prepare-question {
  &__footer{
    display: flex;
    justify-content: space-between !important;
  }
}
.btn-add-question {
  margin: 20px 0;
}
</style>